import { memo, useState } from "react";
import LangIcon from "../../../img/vernac-icon.png";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveUser } from "../../../Redux/Actions/userActions";
const VernacBtn = () => {
  const [select, setSel] = useState(null);
  const [popup, setPopup] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user.info);
  const [language, setLanguage] = useState("en");
  function LanguageChange(lang) {
    let change = {};

    change.language = lang;

    dispatch(saveUser({ ...user, ...change }));

    setLanguage(lang);
    i18next.changeLanguage(lang);
  }

  const VernacHandler = (language) => {
    switch (language) {
      case "हिन्दी":
        LanguageChange("hi");
        break;
      case "English":
        LanguageChange("en");
        break;
    }
  };

  function closeVernac() {
    document.getElementById("closeVernac").click();
  }

  return (
    <div>
      <div
        onClick={() => {
          setPopup((prevState) => !prevState);
        }}
        className="vernac"
        data-bs-toggle="offcanvas" data-bs-target="#selectLang"
      >
        <img src={LangIcon} alt="VernacIcon" data-bs-toggle="offcanvas" data-bs-target="#selectLang" />
        
      </div>
      <div
        className="offcanvas h-auto bg-tr changeAdd-offset changeLang-offset"
        tabIndex="-1"
        id="selectLang"
      >
        <div className="vernac" 
          id="closeVernac"
          data-bs-dismiss="offcanvas"
        >
          <img src={LangIcon} alt="VernacIcon" data-bs-toggle="offcanvas" data-bs-target="#selectLang" />
          
        </div>
        {/* Body */}
        <div className="offcanvas-body bg-white">
          {/* Areas */}
          {["English", "हिन्दी"].map((element, i) => (
              <div
                key={i}
                className={"selectArea" + (i === select ? " checked" : "")}
                onClick={() => {
                  setSel(i);
                  VernacHandler(element);
                  document.getElementById("handleUpdateLang").click();
                }}
              >
                {element}
              </div>
            ))}
          {/* Next Button */}
        </div>
        <div
          className="p-0"
          style={{
            opacity: "0",
            visibility: "hidden",
            width: "0",
            height: "0",
            overflow: "hidden",
          }}
        >
          <button
            id="handleUpdateLang"
            className=""
            disabled={select === null}
            onClick={closeVernac}
          ></button>
        </div>
        <div
          className="bi bi-x-circle fs-lg mx-auto text-white"
          id="closeVernac"
          data-bs-dismiss="offcanvas"
        ></div>
      </div>
    </div>
  );
};
export default memo(VernacBtn);
//
